const ITEMS = [
  "People",
  "Performance",
  "Experience",
  "Leadership",
  "Culture",
  "Coaching",
  "Customer Experience",
  "Employee Experience",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif text-2xl sm:text-3xl italic text-[#F5F5F7]/90 px-6 whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-clay" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-ink py-5 overflow-hidden border-y border-white/10"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
